import React from 'react'
import { makeStyles, LinearProgress } from '@material-ui/core'
import { RISK_STATUS_COLOR_SCALE } from '../ultils/chart-d3-utils'

const useStyles = makeStyles(theme => {
  return {
    categoryItem: {
      marginBottom: '18px',
    },
    categoryItemHeader: {
      display: 'flex',
      marginBottom: '14px',
    },
    categoryName: {
      color: '#181818',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
      letterSpacing: '0em',
      fontStyle: 'Regular',
      styleName: 'note bold',
      fontFamily: 'Inter',
      leadingTrim: 'NONE',
      verticalAlign: 'middle',
    },
    categoryCount: {
      paddingLeft: '4px',
      color: '#181818',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
    },
    categoryPercent: {
      color: '#757575',
      flex: 1,
      textAlign: 'right',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
    },
    categoryProgressLine: {
      height: '4px',
      backgroundColor: '#E8EBEF',
      borderRadius: 2,
    },
    backgroundSevere: {
      backgroundColor: RISK_STATUS_COLOR_SCALE['Fire'],
    },
    backgroundWatch: {
      backgroundColor: RISK_STATUS_COLOR_SCALE['Smoke'],
    },
    backgroundRR: {
      backgroundColor: RISK_STATUS_COLOR_SCALE['Watchlist'],
    },
    backgroundNeutral: {
      backgroundColor: RISK_STATUS_COLOR_SCALE['Neutral'],
    },
  }
})

interface SummaryStatsBoxProps {
  d: any
  total: any
}

const SummaryStatsBox = ({ d, total }: SummaryStatsBoxProps) => {
  const classes = useStyles()

  return (
    <div className={classes.categoryItem}>
      <div className={classes.categoryItemHeader}>
        <div className={classes.categoryName}>{d.title}</div>
        <div className={classes.categoryCount}>({d.count})</div>
        <div className={classes.categoryPercent}>{`${(
          (d.count / total) *
          100
        ).toFixed(0)}%`}</div>
      </div>
      <LinearProgress
        classes={{
          root: classes.categoryProgressLine,
          bar:
            d.title === 'Fire'
              ? classes.backgroundSevere
              : d.title === 'Smoke'
              ? classes.backgroundWatch
              : d.title === 'Watchlist'
              ? classes.backgroundRR
              : classes.backgroundNeutral,
        }}
        variant="determinate"
        value={(d.count / total) * 100}
      />
    </div>
  )
}

export default SummaryStatsBox
